import React, { useState } from "react";
import { Button } from "reactstrap";
import "./index.scss";
import DatePicker from "react-datepicker";
const PacketHeader = ({ _handleTogle, toggle, options }) => {

	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(new Date());
	const submitForm = () => {
		return false;
	}
	return (
		<>
			<div className="packets-header d-flex align-items-center">
				<div className="left-col">
					<h2>Your Most Recent Processed Packets</h2>
					<h3>Your processed packets over the last 7 days</h3>
				</div>
				<div className="right-col btns-blc d-inline-flex align-items-center ms-auto position-relative">
					<Button onClick={() => _handleTogle('Range')} className={`${toggle === "Range" ? 'selected' : ''}`} color="link">
						Range
					</Button>
					<Button onClick={() => _handleTogle('Period')} className={`${toggle === "Period" ? 'selected' : ''}`} color="link">
						Period
					</Button>

					{toggle === "Range" ?
						<>
							<div className="date-time-dropdown-blc d-flex flex-column align-items-center position-absolute">
								<DatePicker
									selected={startDate}
									onChange={(date: Date) => setStartDate(date)}
									maxDate={new Date()}
									className="date-range form-control"
									placeholderText="Start Date"
								/>
								<DatePicker
									selected={endDate}
									onChange={(date: Date) => setEndDate(date)}
									maxDate={new Date()}
									minDate={startDate}
									className="date-range form-control"
									placeholderText="End Date"
								/>
							</div>
						</> :
						<div className="date-time-dropdown-blc d-flex flex-column align-items-center position-absolute">
							<select className="form-select" >
								{options && options.map((item, index) => {
									return (<option key={index} value={item.value}>
										{item.label}</option>);
								})}
							</select>
						</div>

					}
				</div>
			</div>
		</>
	);

}
export default PacketHeader;